import { api } from "apis/homeowner/caseDataHistory";
import { WebApiRequest, HTTP_GET } from "tools/webservice";

export const getCaseRevisions = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getCaseRevisions(controlIdNumber),
  successCallback,
  mountedRef,
});

export const compareCaseRevisions = (controlNumber, fromRevision, toRevision, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.compareCaseRevisions(controlNumber, fromRevision, toRevision),
  successCallback,
  mountedRef,
});
